import { SEGMENTS, VERTICALS } from '../constants/uriConstants';
import { decode, encode, parse } from 'querystring';
import serverVars from 'server-vars';
import get from 'lodash.get';
import querystring from 'querystring';

export function getSellerPath(sellerLabel) {
    return `/${SEGMENTS.SELLER}/${sellerLabel}/`;
}

/**
 * Helper function to deal with the fact that sometimes mobile web pages have the leading segment "/mobile"
 * @param url
 * @returns {[string,*]}
 */
export const stripRoutingSegment = uri => {
    // TODO: Use constants for mobile & resp?
    return uri.replace(/^\/(mobile|resp)/, '');
};

const getParsedSearch = (uriRef = '') => {
    const search = get(uriRef.split('?'), '[1]');

    return decode(search) || {};
};

export function alphabetizeQueryParams(queryParamsObj = {}) {
    const cache = {};
    const newQueryParamsObj = Object.assign({}, queryParamsObj);
    const stringified = JSON.stringify(newQueryParamsObj);
    const keys = Object.keys(newQueryParamsObj).sort();
    const sorted = keys.reduce((prev, cur) => {
        prev[cur] = newQueryParamsObj[cur];
        delete newQueryParamsObj[cur];
        return prev;
    }, {});
    cache[stringified] = sorted;
    return sorted;
}

const createNewUriRef = (uriRef = '', search = {}) => {
    const pieces = uriRef.split('?');
    const href = pieces[0];
    let searchString = search;

    if (typeof search === 'object') {
        const searchTerm = search.q;

        if (searchTerm) {
            search = { ...search, q: encodeURIComponent(searchTerm) };
        }

        searchString = decodeURIComponent(encode(alphabetizeQueryParams(search)));
    }

    if (searchString) {
        searchString = `?${searchString}`;
    }

    return `${href}${searchString}`;
};

export const getNewPaginationUriRef = (uriRef, newPage) => {
    let parsedSearch = getParsedSearch(uriRef);

    if (newPage === 1) {
        //eslint-disable-next-line no-unused-vars
        const { page, ...rest } = parsedSearch;

        parsedSearch = rest;
    } else {
        parsedSearch.page = newPage;
    }

    return createNewUriRef(uriRef, parsedSearch);
};

export const getQueryParam = (uriRef, paramName) => {
    const parsedSearch = getParsedSearch(uriRef);

    return parsedSearch[paramName];
};

export const doubleEncodeSearchTerm = uriRef => {
    if (!uriRef) {
        return '';
    }

    const [path, search] = uriRef.split('?');

    return createNewUriRef(path, parse(search));
};

export function addCdnQueryParams(uriRef) {
    const cdnQueryParams = serverVars.get('cdnQueryParams') || {};
    /**
     * Can be null, can't use defaults. TODO: No reason for it to be null, FIX IT! Can prepopulate
     * it when creating the store.
     */
    if (!uriRef) {
        return '';
    }

    const [pathname, queryString] = doubleEncodeSearchTerm(uriRef).split('?');
    let queryParams = querystring.parse(queryString);
    queryParams = alphabetizeQueryParams(Object.assign({}, cdnQueryParams, queryParams));
    return `${pathname}?${querystring.encode(queryParams)}`;
}

export const uriIncludesVertical = (uri = '') => {
    const verticals = Object.values(VERTICALS);
    return !!uri.split('/').find(segment => verticals.includes(segment));
};

export const isDealersShopUri = (uri = '') => {
    const [href] = uri.split('?');
    return !!href.match(/\/dealers\/(.*)\/shop/);
};
